const objectToFormState = (data) => {
  return Object.entries(data).reduce((acc, [formKey, pairs]) => {
    if (!pairs) {
      return {};
    }
    const newFormState = Object.entries(pairs).reduce(
      (formValueState, [key, value]) => {
        return typeof value !== "undefined" ? {
          ...formValueState,
          [key]: { name: key, value, isTouched: false }
        } : formValueState;
      },
      {}
    );
    return {
      ...acc,
      [formKey]: {
        ...acc[formKey],
        formName: formKey,
        formValid: false,
        formState: {
          ...(acc[formKey] || {}).formState,
          ...newFormState
        }
      }
    };
  }, {});
};
const fieldsToFormState = (data, defaults) => Object.entries(data).reduce(
  (result, [name, value]) => ({
    ...result,
    [name]: {
      name,
      value: String(value),
      isTouched: !!value,
      isValid: !!value,
      ...defaults
    }
  }),
  {}
);
export {
  fieldsToFormState,
  objectToFormState
};
//# sourceMappingURL=object-to-form-state.js.map
